import { render, staticRenderFns } from "./data-global-beef-exports.vue?vue&type=template&id=6199afea&scoped=true&"
import script from "./data-global-beef-exports.vue?vue&type=script&lang=js&"
export * from "./data-global-beef-exports.vue?vue&type=script&lang=js&"
import style0 from "./data-global-beef-exports.vue?vue&type=style&index=0&id=6199afea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6199afea",
  null
  
)

export default component.exports